const formControlLabelFormServiceQuestList = {
  YES: 'Complies',
  NO: 'Doesn\'t comply',
  NA: 'Not applicable',
  needAction: "Actions are mandatory for questions with doesn't comply answer",
  questionDescription: 'Question description'
};


export default formControlLabelFormServiceQuestList;
